import React from 'react';
import { FieldError } from 'react-hook-form';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import {
	useLazyNcziListDiagnosisItemsQuery,
	useLazyNcziListEnumItemsQuery,
} from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';
import DynamicSelect from '../../../../Components/Base/DynamicSelect/DynamicSelect';
import { NCZIReference } from '../../Interfaces/ncziTypes';
import * as yup from 'yup';
import { NCZI_OID } from '../../Enums/ncziOid.enum';
import useNCZIReference from '../../Hooks/useNCZIReference';

export interface NCZIReferenceSelectItem {
	label: string;
	value: NCZIReference;
}

export const NCZIReferenceValidator = (name: string) =>
	yup.object({
		label: yup.string(),
		value: yup
			.object({
				code: yup.string().required(name),
				displayName: yup.string(),
				scheme: yup.object({
					oid: yup.string(),
					version: yup.string(),
				}),
			})
			.typeError(name),
	});

interface Props {
	oid: string;
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
	showCode?: boolean;
	showAbbr?: boolean;
	portal?: boolean;
}

const NCZIReferenceSearchSelect = React.forwardRef<
	any,
	React.PropsWithChildren<Props>
>((props, ref) => {
	const { value, onChange, showCode = false, showAbbr = false } = props;
	const [getListEnumItems] = useLazyNcziListEnumItemsQuery();
	const { handleSearchDiagnosisItem } = useNCZIReference();

	useEffectAsync(async () => {
		if (value) onChange?.(value);
	});

	const handleSearchItem = async (
		searchInput: string,
	): Promise<SelectValue[]> => {
		if (props.oid === NCZI_OID.DIAGNOSIS) {
			return handleSearchDiagnosisItem(searchInput, showCode);
		} else {
			const { items: listEnumItems } = await getListEnumItems({
				oid: props.oid,
				fulltext: searchInput,
			}).unwrap();

			const items: SelectValue[] = [];

			console.log('----------------', props.oid);

			for (const listEnumItem of listEnumItems?.data || []) {
				if (listEnumItem && listEnumItem.code) {
					items.push({
						label:
							(showAbbr ? listEnumItem.abbreviation + ': ' : '') +
							(showCode ? listEnumItem.code + ' - ' : '') +
							(listEnumItem.name || ''),
						value: {
							displayName: listEnumItem.name || '',
							code: listEnumItem.code,
							scheme: {
								oid: listEnumItem.enum?.oid || '',
								version: listEnumItem.enum?.version || '',
							},
						},
					});
				}
			}

			console.log('items', items);

			return items;
		}
	};

	return <DynamicSelect searchItems={handleSearchItem} {...props} />;
});

export default NCZIReferenceSearchSelect;
